// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZFORM_LOCATION_SELECT_ENTER_SOME_CHARS = "<em>Zadaj aspo\u0148 2 znaky z n\u00e1zvu by&shy;dli&shy;ska</em>";
export const BZFORM_LOCATION_SELECT_NO_RESULTS = "<em>Nena\u0161li sme \u017eiadne mesto ani obec. Ne&shy;spra&shy;vi&shy;la si preklep v n\u00e1zve?</em>";
export const BZFORM_LOCATION_SELECT_SEARCHING = "<em>H\u013ead\u00e1m...</em>";
